import { Divider, makeStyles } from '@material-ui/core';
import { getBillingTypeDescription } from 'doc-mate-store/lib/constants/accessorial';
import { AdditionalBillingLeg } from 'doc-mate-store/lib/models/AdditionalBillingLeg';
import { observer } from 'mobx-react-lite';
import React from 'react';
import Labeled from '../Labeled';
type Props = {
  additionalBilling: AdditionalBillingLeg;
};

const AdditionalBillingDetail: React.FC<Props> = ({ additionalBilling }) => {
  const classes = useStyles();

  return (
    <div>
      <div className={classes.loadDetailItem}>
        <Labeled label="Billing Type">
          {getBillingTypeDescription(additionalBilling.billingType)}
        </Labeled>
      </div>

      <div className={classes.loadDetailItem}>
        <Labeled label="Bill of Lading Number">
          {additionalBilling.billOfLadingNumber || 'To be provided'}
        </Labeled>
      </div>
      <div className={classes.loadDetailItem}>
        <Labeled label="AS400 Manifest Number">
          {additionalBilling.baseAs400ManifestNumber}
        </Labeled>
      </div>
      {additionalBilling.notes && (
        <div className={classes.loadDetailItem}>
          <Labeled label="Notes">{additionalBilling.notes}</Labeled>
        </div>
      )}
      {additionalBilling.deniedReason && (
        <div className={classes.loadDetailItem}>
          <Labeled label="Denied Reasons">
            {additionalBilling.deniedReason}
          </Labeled>
        </div>
      )}

      <Divider />
    </div>
  );
};

const useStyles = makeStyles(theme => ({
  loadDetailItem: {
    alignItems: 'center',
    display: 'flex',
    paddingTop: theme.spacing(1),
    paddingRight: theme.spacing(3),
    paddingBottom: theme.spacing(1),
    paddingLeft: theme.spacing(3),
    // fontWeight: theme.typography.fontWeightMedium,
    fontWeight: 500,
  },
  loadDetailItem2: {
    alignItems: 'start',
  },
  loadLocation: {
    paddingTop: theme.spacing(1),
    paddingRight: theme.spacing(3),
    paddingBottom: theme.spacing(1),
    paddingLeft: theme.spacing(3),
  },
}));

export default observer(AdditionalBillingDetail);
